<template>
  <thux-table
    :instance="instance"
    :instance-name="instanceName"
    :order-by-dict="orderByDict"
    :goBack="goBack"
    :list="list"
    :fieldName="fieldName"
    :fields="fields"
    :fields-column="fieldsColumn"
    :select-all="selectAll"
    :selected-list="selectedList"
    :get-local-selected-all="getLocalSelectedAll"
    :local-selected-list="localSelectedList"
    @check-all="checkAll"
    @check-none="checkNone"
    @set-selected-row="setSelectedRow"
    :show-checks="showChecks"
    :show-detail-button="showDetailButton"
    @change-status="changeInstanceStatus"
    @sort-changed="orderTable"
    @remove-order-by="removeOrderFromTable"
    @open-detail-form="$emit('open-detail-form', $event)"
  >
    <template slot="group_names" slot-scope="row">
      <div v-if="row.item.group_names">
        <span
          v-for="group in row.item.group_names.split(',')"
          :key="group"
          class="tag"
        >
          {{ group }}
        </span>
      </div>
    </template>
  </thux-table>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { TYPES as OWNER_ORG_TYPES } from './store'
import { hasPerm } from '@/components/PermissionHelper'

import ThuxTableMixin from '../../../../../components/thux-table/ThuxTableMixin'
import ThuxTableChecksMixin from '../../../../../components/thux-table/thux-table-checks/ThuxTableChecksMixin'

export default {
  name: 'OwnerOrganizationTable',
  mixins: [ThuxTableMixin, ThuxTableChecksMixin],
  data () {
    return {
      fields: [
        {
          key: 'checks',
          label: this.$t('Checks')
        },
        {
          key: 'status',
          label: this.$t('Status'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: true,
          value: 'status'
        },
        {
          key: 'name',
          label: this.$t('Business Name'),
          type: 'text',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: true,
          value: 'name'
        },
        {
          key: 'vat_number',
          label: this.$t('VAT number'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: true,
          value: 'vat_number'
        },
        {
          key: 'ssn',
          label: this.$t('SSN'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: true,
          value: 'ssn'
        },
        {
          key: 'pec',
          label: this.$t('PEC'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: true,
          value: 'pec'
        },
        {
          key: 'sdi_code',
          label: this.$t('SDI'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: true,
          value: 'sdi_code'
        },
        {
          key: 'group_names',
          label: this.$t('Categories'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          custom: true
        },
        {
          key: 'action',
          label: this.$t('Actions'),
          tdClass: 'text-right text-nowrap',
          thClass: 'text-right text-nowrap'
        }
      ],
      fieldsColumn: ['status', 'name', 'vat_number', 'ssn', 'pec', 'sdi_code', 'group_names'],
      showDocumentsButton: true,
      showDownloadDocumentsButton: true
    }
  },
  computed: {
    ...mapGetters({
      selectAll: OWNER_ORG_TYPES.GENERIC.organization.ownerorganization.LIST.GETTERS.selectAll,
      selectedList: OWNER_ORG_TYPES.GENERIC.organization.ownerorganization.LIST.GETTERS.selectedList
    }),
    showChecks () {
      return true
    },
    showEditButton () {
      return false
    },
    showDetailButton () {
      return hasPerm('organization_ownerorganization_retrieve')
    }
  },
  methods: {
    ...mapMutations({
      setList: OWNER_ORG_TYPES.GENERIC.organization.ownerorganization.LIST.MUTATIONS.setList,
      setSelectedList:
        OWNER_ORG_TYPES.GENERIC.organization.ownerorganization.LIST.MUTATIONS.setSelectedList,
      setSelectAll: OWNER_ORG_TYPES.GENERIC.organization.ownerorganization.LIST.MUTATIONS.setSelectAll
    }),
    ...mapActions({
      ...OWNER_ORG_TYPES.GENERIC.organization.ownerorganization.LIST.ACTIONS
    })
  }
}
</script>
